import { cn } from '@/lib/cn';

type SkeletonProps = { className?: string };

/** surface-muted block matching the final layout; the pulse is removed under reduced motion (global rule). */
export function Skeleton({ className }: SkeletonProps) {
  return <div aria-hidden="true" className={cn('animate-pulse rounded-md bg-surface-muted', className)} />;
}
